import { render } from "./SetupTwoFaAtUserProfile.vue?vue&type=template&id=a41bede8&scoped=true"
import script from "./SetupTwoFaAtUserProfile.vue?vue&type=script&lang=js"
export * from "./SetupTwoFaAtUserProfile.vue?vue&type=script&lang=js"

import "./SetupTwoFaAtUserProfile.vue?vue&type=style&index=0&id=a41bede8&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41bede8"]])

export default __exports__